declare global {
  interface Window {
    pendo: any;
  }
}

function isProduction() {
  return process.env.NX_ENV === 'production';
}

export const pendo = {
  isReady: () => {
    if (isProduction()) {
      return window.pendo?.isReady?.();
    }
  },
  isAnonymousVisitor: () => {
    if (isProduction()) {
      return window.pendo?.isAnonymousVisitor?.();
    }
  },
  initializeAnonymous: () => {
    if (isProduction()) {
      window.pendo?.initialize?.({
        visitor: {
          id: 'VISITOR-UNIQUE-ID',
        },
        additionalApiKeys: ['412c2ccc-f911-4709-4be5-8b2d646304c6'],
      });
    } else {
      console.log('Pendo | initializeAnonymous()', {
        visitor: {
          id: 'VISITOR-UNIQUE-ID',
        },
      });
    }
  },
  initializeAuthenticated: (email: string, tenantDisplayName?: string) => {
    if (isProduction()) {
      window.pendo?.initialize?.({
        visitor: {
          id: email,
        },

        account: {
          id: tenantDisplayName,
        },
        additionalApiKeys: ['412c2ccc-f911-4709-4be5-8b2d646304c6'],
      });
    } else {
      console.log('Pendo | initializeAuthenticated()', {
        visitor: {
          id: email,
        },
        account: {
          id: tenantDisplayName,
        },
      });
    }
  },
  identify: (email: string, tenantDisplayName?: string) => {
    if (isProduction()) {
      window.pendo?.identify?.({
        visitor: {
          id: email,
        },

        account: {
          id: tenantDisplayName,
        },
      });
    } else {
      console.log('Pendo | identify()', {
        visitor: {
          id: email,
        },

        account: {
          id: tenantDisplayName,
        },
      });
    }
  },
  trackPageView: (page: string, user?: string) => {
    if (isProduction()) {
      if (!pendo.isSendingEvents()) return;

      window.pendo?.track?.(page, {
        user: user,
      });
    } else {
      console.log('Pendo | trackPageView()', {
        page,
        user,
      });
    }
  },

  track: (eventName: string, trackingInformation: Record<string, unknown>) => {
    if (isProduction()) {
      window.pendo?.track?.(eventName, trackingInformation);
    } else {
      console.log('Pendo | track()', {
        eventName,
        trackingInformation,
      });
    }
  },

  stopSendingEvents: () => {
    if (isProduction()) {
      window.pendo?.stopSendingEvents?.();
    } else {
      console.log('Pendo | stopSendingEvents()');
    }
  },

  startSendingEvents: () => {
    if (isProduction()) {
      window.pendo?.startSendingEvents?.();
    } else {
      console.log('Pendo | startSendingEvents()');
    }
  },

  isSendingEvents: () => {
    if (isProduction()) {
      return window.pendo?.isReady?.() && window.pendo?.isSendingEvents?.();
    }
  },
};
